import { useEffect, useMemo, useState } from "react";
import api, { formatError } from "@/lib/api";
import { toast } from "sonner";

/**
 * Load the sucursales the current user is allowed to see and manage
 * the current selection for this tab (does NOT persist across tabs/reloads).
 * - auto-picks if only 1 is available (skip picker)
 * - returns { sucursales, current, setCurrent, clear, loading }
 */
export function useSucursalGate() {
  const [sucursales, setSucursales] = useState([]);
  const [current, setCurrent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/sucursales");
        if (!alive) return;
        setSucursales(data);
        if (data.length === 1) {
          setCurrent(data[0]);
        }
      } catch (e) {
        if (alive) toast.error(formatError(e.response?.data?.detail) || "Error cargando sucursales");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const clear = () => setCurrent(null);
  const value = useMemo(
    () => ({ sucursales, current, setCurrent, clear, loading }),
    [sucursales, current, loading],
  );
  return value;
}
